module.exports = __webpack_public_path__ + "img/nav-map.b7d42165.svg";